/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiCreateMailboxDto,
  ApiCurrentMailBoxDto,
  ApiGetMailBoxResponseDto,
  ApiTakenDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class MailServer<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Mail Server
   * @name MailServerControllerGetAllMailboxes
   * @summary Get mailbox for the current user
   * @request GET:/mail-server/accounts
   * @secure
   * @response `200` `ApiGetMailBoxResponseDto` List of mailboxes for the authenticated user.
   */
  mailServerControllerGetAllMailboxes = (params: RequestParams = {}) =>
    this.request<ApiGetMailBoxResponseDto, ApiBaseError>({
      path: `/mail-server/accounts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Mail Server
   * @name MailServerControllerCreateAccount
   * @summary Create a new email account
   * @request POST:/mail-server/accounts
   * @secure
   * @response `201` `ApiCurrentMailBoxDto` Returns the created email address.
   */
  mailServerControllerCreateAccount = (
    data: ApiCreateMailboxDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiCurrentMailBoxDto, ApiBaseError>({
      path: `/mail-server/accounts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Mail Server
   * @name MailServerControllerCheckAccountAvailability
   * @summary Check if an email account is taken
   * @request GET:/mail-server/accounts/check
   * @secure
   * @response `200` `ApiTakenDto` Returns whether the account is taken or not.
   */
  mailServerControllerCheckAccountAvailability = (
    query: {
      /* Template custom: data-contract-jsdoc */
      search: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiTakenDto, ApiBaseError>({
      path: `/mail-server/accounts/check`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Mail Server
   * @name MailServerControllerDeleteAccount
   * @summary Delete an email account
   * @request DELETE:/mail-server/accounts/{username}
   * @secure
   * @response `200` `ApiCurrentMailBoxDto` Returns the deleted email address.
   */
  mailServerControllerDeleteAccount = (
    username: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiCurrentMailBoxDto, ApiBaseError>({
      path: `/mail-server/accounts/${username}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Mail Server
   * @name MailServerControllerGetDomainMailBox
   * @summary Get domain name for inbox mail
   * @request GET:/mail-server/domain
   * @secure
   * @response `200` `void` Domain name returned successfully.
   */
  mailServerControllerGetDomainMailBox = (params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/mail-server/domain`,
      method: "GET",
      secure: true,
      ...params,
    });
}
